import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ErrorMessage, PageHeader } from "@redriver/cinnamon";
import { requestLogout } from "features/System/Logout/actions";
import { setPersistentQueryParams } from "features/System";
import { SystemPageContent } from "components/pages";

const CRMLogoutPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation("system");

  const { error } = location.state || {};

  useEffect(() => {
    dispatch(requestLogout());
    dispatch(setPersistentQueryParams({}));
  }, [dispatch]);

  return (
    <SystemPageContent>
      <PageHeader>{t("Sign_Out")}</PageHeader>

      {error ? (
        <ErrorMessage header="Logout Failed" error={error} />
      ) : (
        <p className="crm-login-message">
          {t("You_are_logged_out_please_log_in_via_your_CRM_system")}
        </p>
      )}
    </SystemPageContent>
  );
};

export default CRMLogoutPage;
